import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "posRe"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  style: {},
  class: "w100"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 2,
  class: "clear"
}
const _hoisted_6 = { class: "ml10" }
const _hoisted_7 = {
  key: 0,
  class: "w100 kaigyo fs12 ddgrey mt15 pad15 rad10 ofs",
  style: { background: `#f7f7f7`, padding: `20px 26px` }
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "w100 pad5 skyblueBorder l2 with_white_bg centered fw600 rad8 hoverGrey" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["href"]
const _hoisted_16 = { key: 2 }
const _hoisted_17 = ["href"]
const _hoisted_18 = { key: 3 }
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = {
  key: 1,
  class: "posRe fl pad10 posRe mb15"
}
const _hoisted_23 = { class: "w100 llgreyBg pad20 rad20" }
const _hoisted_24 = {
  key: 0,
  class: "fw600 fw14 mb10"
}
const _hoisted_25 = {
  key: 1,
  class: "fw600 fw14 mb10"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  style: { lineHeight: `60px` },
  class: "whiteColor fw600 fs14"
}
const _hoisted_29 = { key: 1 }
const _hoisted_30 = ["src", "width", "height", "onMouseenter", "onClick"]
const _hoisted_31 = { key: 2 }
const _hoisted_32 = ["src", "width", "height", "onClick", "onMouseover", "onMouseleave"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = {
  key: 3,
  class: "fs12 fw600 ddgrey mt5"
}
const _hoisted_35 = {
  class: "posAb circleBlueButton whiteColor fw600",
  style: { top: `-6px`, right: `-6px`, background: `#69d54f` }
}
const _hoisted_36 = ["src"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_PopupInnerContent = _resolveComponent("PopupInnerContent")!

  return (_ctx.displayType == `fixed`)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.appo.selectedMags[0].team_name)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.Util.isPresent(_ctx.appo.selectedMags[0].profile_image_urls))
                  ? (_openBlock(), _createBlock(_component_UserIcon, {
                      key: 0,
                      imageUrl: _ctx.appo.selectedMags[0].profile_image_urls[0],
                      canEdit: false,
                      updateSelf: false,
                      width: 90,
                      class: _normalizeClass(`${_ctx.isSP ? `w100 centered` : `fl`}`)
                    }, null, 8, ["imageUrl", "class"]))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _ctx.$getAssetImageUrl(`/assets/icons/usertype_grey.png`),
                      width: "90",
                      height: "90",
                      class: _normalizeClass(`${_ctx.isSP ? `w100 centered` : `fl`}`)
                    }, null, 10, _hoisted_4)),
                (_ctx.isSP)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(`${_ctx.isSP ? `w100 centered` : `fl`}`),
                  style: _normalizeStyle({
                        width: _ctx.isSP ? `` : `calc(100% - 130px)`,
                    })
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`fs14 fw600 ddgrey  ml10 ${_ctx.appo.selectedMags[0].description ? `mt5` : `mt40`}`)
                    }, " 今回は、「" + _toDisplayString(_ctx.appo.selectedMags[0].team_name) + "」が担当いたします。 ", 3),
                    (_ctx.appo.selectedMags[0].description)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.autoLink(_ctx.appo.selectedMags[0].description), (text, textindex) => {
                            return (_openBlock(), _createElementBlock("span", { key: textindex }, [
                              (text.match(_ctx.TemplateUtil.buttonRegex) || text.match(_ctx.TemplateUtil.buttonRegexWithOptions))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                    _createElementVNode("a", {
                                      href: `${text.match(_ctx.TemplateUtil.buttonLinkRegex)[0].replace(`(`, ``).split(`)`)[0]}`,
                                      class: _normalizeClass(`${_ctx.isSP ? `fs12` : `fs14`}`),
                                      rel: "noopener noreferrer nofollow",
                                      target: "_blank",
                                      style: { textDecoration: `none` }
                                    }, [
                                      _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("span", _hoisted_11, _toDisplayString(text.match(_ctx.TemplateUtil.buttonTextRegex)[0].replace(`[`, ``).replace(`]`, ``)), 1),
                                        _hoisted_12
                                      ]),
                                      _hoisted_13
                                    ], 10, _hoisted_9)
                                  ]))
                                : (text.match(_ctx.TemplateUtil.regex))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                      _createElementVNode("a", {
                                        href: text,
                                        class: _normalizeClass(`innerLink skyblue fw600 ${_ctx.isSP ? `fs12` : ``}`),
                                        target: "_blank",
                                        rel: "noopener noreferrer nofollow",
                                        style: { textDecoration: `underline` }
                                      }, _toDisplayString(text), 11, _hoisted_15)
                                    ]))
                                  : (text.match(_ctx.TemplateUtil.mailRegex))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                        _createElementVNode("a", {
                                          href: `mailto:${text}`,
                                          class: _normalizeClass(`innerLink skyblue fw600 ${_ctx.isSP ? `fs12` : ``}`),
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                          style: { textDecoration: `underline` }
                                        }, _toDisplayString(text), 11, _hoisted_17)
                                      ]))
                                    : (
                                        text.match(_ctx.TemplateUtil.telRegex1) ||
                                        text.match(_ctx.TemplateUtil.telRegex2) ||
                                        text.match(_ctx.TemplateUtil.telRegex3)
                                    )
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                          _createElementVNode("a", {
                                            href: `tel:${text}`,
                                            class: _normalizeClass(`innerLink skyblue fw600 ${_ctx.isSP ? `fs12` : ``}`),
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            style: { textDecoration: `underline` }
                                          }, _toDisplayString(text), 11, _hoisted_19)
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", {
                                          key: 4,
                                          class: "fw600",
                                          style: _normalizeStyle({ lineHeight: `1.6` })
                                        }, _toDisplayString(text), 5))
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_20
                ], 6),
                _hoisted_21
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_ctx.displayType == `selectable`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (_ctx.mags.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.$t(`schedule.available_to_select_person_in_charge`)), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_25, "今回は、「" + _toDisplayString(_ctx.mags[0].team_name) + "」が担当いたします", 1)),
            _hoisted_26,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mags, (mag, magindex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `${magindex}${mag.selected}${mag.id}${mag.systemUpdatedAt}${_ctx.systemUpdatedAt}${_ctx.popupMag?.id}`,
                class: _normalizeClass(`fl centered sel${mag.id} mr8 posRe team_${mag.name}`)
              }, [
                (mag.id == `any`)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(`fl pointer mr10 ddgreyBg centered posRe`),
                      style: { width: `60px`, height: `60px`, borderRadius: `50%` },
                      onClick: ($event: any) => (_ctx.clickMag(mag))
                    }, [
                      _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t(`schedule.any_person`)), 1)
                    ], 8, _hoisted_27))
                  : (mag.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        (mag.profile_image_urls)
                          ? (_openBlock(), _createBlock(_component_UserIcon, {
                              key: 0,
                              imageUrl: mag.profile_image_urls[0],
                              canEdit: false,
                              updateSelf: false,
                              width: _ctx.popupMag?.id == mag.id ? 63 : 60,
                              onMouseenter: ($event: any) => (_ctx.showMagPopup(mag, $event)),
                              onMouseleave: _ctx.hideMagPopup,
                              onClick: ($event: any) => (_ctx.clickMag(mag)),
                              class: "pointer"
                            }, null, 8, ["imageUrl", "width", "onMouseenter", "onMouseleave", "onClick"]))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: _ctx.$getAssetImageUrl(`/assets/icons/usertype_grey.png`),
                              width: _ctx.popupMag?.id == mag.id ? 63 : 60,
                              height: _ctx.popupMag?.id == mag.id ? 63 : 60,
                              onMouseenter: ($event: any) => (_ctx.showMagPopup(mag, $event)),
                              onMouseleave: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideMagPopup && _ctx.hideMagPopup(...args))),
                              onClick: ($event: any) => (_ctx.clickMag(mag))
                            }, null, 40, _hoisted_30))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        (mag.profile_image_urls)
                          ? (_openBlock(), _createBlock(_component_UserIcon, {
                              key: 0,
                              imageUrl: mag.profile_image_urls[0],
                              canEdit: false,
                              updateSelf: false,
                              width: _ctx.popupMag?.id == mag.id ? 63 : 60,
                              onMouseenter: ($event: any) => (_ctx.mouseoverImage(mag)),
                              onMouseleave: ($event: any) => (_ctx.mouseleaveImage(mag)),
                              onClickImage: ($event: any) => (_ctx.clickMag(mag)),
                              class: "pointer"
                            }, null, 8, ["imageUrl", "width", "onMouseenter", "onMouseleave", "onClickImage"]))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: _ctx.$getAssetImageUrl(`/assets/icons/usertype_grey.png`),
                              width: _ctx.popupMag?.id == mag.id ? 63 : 60,
                              height: _ctx.popupMag?.id == mag.id ? 63 : 60,
                              onClick: ($event: any) => (_ctx.clickMag(mag)),
                              onMouseover: ($event: any) => (_ctx.mouseoverImage(mag)),
                              onMouseleave: ($event: any) => (_ctx.mouseleaveImage(mag))
                            }, null, 40, _hoisted_32))
                      ])),
                _hoisted_33,
                (mag.team_name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.truncate(mag.team_name, 5)), 1))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_35, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/check_wt.png`),
                    width: "17",
                    height: "17",
                    style: { marginTop: `-2px` }
                  }, null, 8, _hoisted_36)
                ], 512), [
                  [_vShow, mag.selected]
                ])
              ], 2))
            }), 128)),
            _hoisted_37,
            (_ctx.showPopup)
              ? (_openBlock(), _createBlock(_component_PopupInnerContent, {
                  key: 2,
                  mag: _ctx.popupMag,
                  style: _normalizeStyle({ position: 'fixed', top: _ctx.popupTop + 'px', left: _ctx.popupLeft + 'px', zIndex: 9999 }),
                  onMouseover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                  onMouseleave: _ctx.hideMagPopup
                }, null, 8, ["mag", "style", "onMouseleave"]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_38
        ]))
      : _createCommentVNode("", true)
}